var validUrl = require('valid-url')
var _ = require('lodash')

const isNullOrEmpty = (value) => {
  if (value === 0) {
    return false
  }
  if (_.isBoolean(value)) {
    return false
  }
  if (value === null || value === undefined) {
    return true
  }
  if (_.isArray(value)) {
    return value.length === 0
  }
  if (_.isString(value)) {
    return value.trim() === ""
  }
}

const passwordValidator = (value) => {
  if (!value) {
    return false
  }

  const hasLowerCase = /[a-zæøå]/.test(value)
  const hasUpperCase = /[A-ZÆØÅ]/.test(value)
  const hasNumber = /[\d]/.test(value)
  const hasSymbol = /[\@\#\$\%\^\&\*\-_\\+\=\[\]\{\}\|\\\:\‘\,\.\?\/\`\~\“\(\)\;]/.test(value)

  let counter = 0
  if (hasLowerCase) {
    counter++
  }
  if (hasUpperCase) {
    counter++
  }
  if (hasNumber) {
    counter++
  }
  if (hasSymbol) {
    counter++
  }

  if (value.length < 10 || counter < 3) {
    return false
  }

  return true
}

const passwordMatchValidator = (password, confirmPassword) => {
  if (password !== confirmPassword) {
    return false
  }
  return true
}

const usernameValidator = (value) => {
  if (!value) {
    return false
  }
  if (value && /[^a-zA-Z0-9-_.]/g.test(value)) {
    return false
  }
  return true
}

const emailValidator = (value) => {
  if (value && /^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
    return true
  }
  return false
}

const emailToUsername = (email = '') => {
  return email.trim().replace(/(^\w+([\+.-]?\w+)*)@(\w+([\.-]?\w+)*)(\.\w{2,3})+$/, '$1-$3')
}

const regexValidator = (value, regex) => {
  try {
    if (value && value?.match(new RegExp(regex))) {
      return true
    }
    return false
  } catch (e) {
    return false
  }
}

const isInvalidUrl = (urls) => {
  var isInvalid = false
  if (_.isArray(urls)) {
    urls?.some(urlData => {
      const validation = validUrl.isWebUri(urlData?.url)
      if (!validation) { 
        isInvalid = true 
        return null
      }
      return null
    })
  }
  else if (_.isObject(urls)) {
    const validation = validUrl.isWebUri(urls?.url)
    if (!validation) { isInvalid = true }
  }
  else if (_.isString(urls)) {
    const validation = validUrl.isWebUri(urls)
    if (!validation) { isInvalid = true }
  }
  return isInvalid
}

const checkFormValidity = (formErrors, validationConfig) => {
  if (!formErrors || !Array.isArray(validationConfig)) {
    return true
  }

  return Object.keys(formErrors)
    .filter(key => validationConfig.find(field => field.key === key))
    .every(key => formErrors[key] === null)
}


export default {
  isNullOrEmpty,
  passwordValidator,
  passwordMatchValidator,
  usernameValidator,
  emailValidator,
  emailToUsername,
  regexValidator,
  isInvalidUrl,
  checkFormValidity
}
